export const ANIMATION_STYLE_END = { height: '0px', overflow: 'hidden' };
export const ANIMATION_STYLE_START = { height: '*', overflow: 'hidden' };
